import { Spinner, Typography } from '@norges-domstoler/dds-components';
import { useTranslation } from 'react-i18next';
import { Page } from '../Page/Page';
import { Colors } from '../Tokens/colors';

export function PageLoader() {
  const { t } = useTranslation();
  return (
    <Page>
      <div className="page-loader-fade mt-40 flex w-full flex-col items-center justify-center gap-4">
        <Spinner color={Colors.DdsColorPrimaryBase} size="80px" />
        <Typography>{t('loading.page')}</Typography>
      </div>
    </Page>
  );
}
